import { motion } from "framer-motion";

// Staggered scroll-reveal wrapper. Premium easing per design guidelines.
export const Reveal = ({ children, delay = 0, y = 40, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);
